import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_124_add_sales_return_voucher: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Sales return voucher",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "sales_ret_add",
        TableName: "sales_return",
        DisplayName: "sales_return",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Sales return details",
            BindValue: "con_sales_return_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "Invoice  No.",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "drp_sales_ret",
                Json_Attribute: "invoice_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                showInSummary: true,
                LookupName: "sales_invoice",
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Invoice No. is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Return No.",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sales_return_no",
                Json_Attribute: "sales_return_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                AutoPopulate: true,
                IsReadOnly: true,
                AutoPopulate_format: "SALRET_[******]",
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Date",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_sales_date",
                Json_Attribute: "sales_return_date",
                componentType: ComponentType.DATE_FIELD,
                DefaultToday: true,
                showInSummary: true,
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Date is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Mobile",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_mobile",
                Json_Attribute: "mobile_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: false,
                BindParent: {
                  drp_sales_ret: "mobile",
                },
                IsVerticalView: true,
                inputType: InputType.PHONE,
              },
              {
                IncludeLabel: true,
                Label: "TRN.",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_customer_taxregno",
                Json_Attribute: "customer_taxregno",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                BindParent: {
                  drp_sales_ret: "trn_no",
                },
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Customer name",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_customer_name",
                Json_Attribute: "customer_name",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                BindParent: {
                  drp_sales_ret: "customername",
                },
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Ref No.",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_customer_refno",
                Json_Attribute: "customer_refno",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: false,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Ref date",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sales_ref_date",
                Json_Attribute: "ref_date",
                componentType: ComponentType.DATE_FIELD,
                DefaultToday: true,
                showInSummary: true,
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Fax",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_fax",
                Json_Attribute: "fax",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                BindParent: {
                  drp_purchase: "fax",
                },
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Remarks",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_remarks",
                Json_Attribute: "remarks",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Return amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_return_amount",
                Json_Attribute: "returned_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: false,
                Default_Value: "0",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "sales_return_details",
            label: "Sales return details",
            tableName: "sales_return_details",
            lookupName: "sales_invoice_details",
            parentField: "drp_sales_ret",
            BindValue: "sales_return_details",
            childControls: [
              {
                IncludeLabel: true,
                Label: "Invoice No.",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_invoice_no",
                Json_Attribute: "invoice_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_amount",
                Json_Attribute: "amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                Default_Value: "0",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
          textColor: "#FFFFFF",
          padding: 12,
          borderRadius: 8,
        },
      },
    ],
  },
];


